import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { CwsIconData } from "../vo/cws-icon-data.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetCwsIconDataResponse = {
  IconCode: string,
  IconCodeBranch: string,
  IconGroupCode: string,
  IconName: string,
  IconImageUrl: string,
  IconAlternativeText: string,
  DelivCatalogIdStart: string,
  DelivCatalogIdEnd: string,
  DelivEndDate: string,
  IconDiv: string,
  ArrangeDiv: string,
  IconExplain: string,
  OutputDiv: string,
  UpdateDate: string
}[];

/**
 * アイコン情報一覧取得サービス
 * @export GetCwsIconDataService
 * @class GetCwsIconDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCwsIconDataService extends PlessJsonResponderSub<GetCwsIconDataResponse> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsIconDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsIconDataService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getCwsIconData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsIconDataService
   */
  success(data: GetCwsIconDataResponse) {
    this.model.cwsIconDataList = data.map(_ => new CwsIconData(
      _.IconCode,
      _.IconCodeBranch,
      _.IconGroupCode,
      _.IconName,
      _.IconImageUrl,
      _.IconAlternativeText,
      _.DelivCatalogIdStart,
      _.DelivCatalogIdEnd,
      _.DelivEndDate,
      _.IconDiv,
      _.ArrangeDiv,
      _.IconExplain,
      _.OutputDiv,
      _.UpdateDate
    ))
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
